export function IndividualIcon() {
	return (
		<svg
			fill="none"
			height="15"
			viewBox="0 0 14 15"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.8696 1.63553C8.30826 1.06448 7.52425 0.750002 6.65889 0.750002C5.78891 0.750002 5.0023 1.06257 4.44356 1.63009C3.87877 2.20386 3.60359 2.98366 3.6682 3.8257C3.79627 5.48694 5.13787 6.83834 6.65889 6.83834C8.1799 6.83834 9.51919 5.48722 9.64929 3.82624C9.71476 2.99181 9.43785 2.21365 8.8696 1.63553ZM11.8268 13.7499H1.67322C1.54032 13.7516 1.4087 13.7253 1.28795 13.6729C1.16719 13.6206 1.06034 13.5436 0.975159 13.4474C0.787664 13.2362 0.712089 12.9478 0.768049 12.6562C1.0115 11.3836 1.77129 10.3146 2.96549 9.5642C4.02642 8.89802 5.37033 8.53136 6.75 8.53136C8.12967 8.53136 9.47358 8.89829 10.5345 9.5642C11.7287 10.3144 12.4885 11.3834 12.732 12.6559C12.7879 12.9476 12.7123 13.236 12.5248 13.4471C12.4397 13.5433 12.3328 13.6204 12.2121 13.6728C12.0913 13.7252 11.9597 13.7515 11.8268 13.7499Z"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
		</svg>
	);
}
